import theme from '../../../../ui/theme/'
const styles = {
  section: {
    padding: theme => theme.spacing(4, 0),
  },
  title: {
    marginBottom: theme => theme.spacing(4),
  },
  buttonsWrapper: {
    marginBottom: theme => theme.spacing(1.25),
  },
  fields: {
    display: 'flex',
    flexWrap: 'wrap',
    rowGap: theme => theme.spacing(3),
    columnGap: theme => theme.spacing(2),
    mt: 3,
    marginBottom: theme => theme.spacing(0.25),
    [theme.breakpoints.up('sm')]: {
      mt: 2,
      rowGap: theme => theme.spacing(1),
    },
    '& .MuiInputBase-colorSuccess .MuiInput-input': {
      boxShadow: `0 0 0 100px ${theme => theme.palette.success.light} inset`,
      backgroundColor: theme => theme.palette.success.light,
      borderColor: theme => theme.palette.green.light,
      borderBottomColor: theme => theme.palette.success.dark,
    },
  },
  selectField: {
    minWidth: 240,
  },
  alert: {
    width: '100%',
    maxWidth: 533,
    '& .MuiTypography-h3medium': { marginBottom: 0 },
    '&.MuiAlert-root': {
      marginTop: theme => theme.spacing(1.5),
      [theme.breakpoints.up('sm')]: {
        mt: 1.25,
      },
    },
  },
  pickUpAlert: {
    maxWidth: '640px',
    marginBottom:  theme.spacing(1)
  },
  alertText: {
    color:  theme.palette.neutral.main
  }
}

export default styles
